import mainApp from './core/Main';
import publicGeoProfile from './geo/public.geo-profile';

mainApp.init().done(() => {
  publicGeoProfile([
    'view-public-geo-profile',
  ]);
  return true;
}).fail(() => {
  console.error('Main app initialization failed!');
});
